import {PureComponent, Fragment} from 'react'
import {Card, CardBody, CardText, CardTitle} from 'reactstrap'
import {Link, Redirect} from 'react-router-dom'

import CallToActions from '../../components/CallToActions/CallToActions.jsx'
import DefaultLayout from '../Layout/DefaultLayout.jsx'
import Header from '../../components/Header/Header.jsx'
import IllustratedDiv from '../../components/IllustratedDiv/IllustratedDiv.jsx'

import {generate} from '../../routes.js'

import './OurVision.scss'

import goal from './images/goal.jpg?size=600'
import header from './images/header.jpg?size=2000'
import method from './images/method.jpg?size=600'
import growthGraph from './images/growth.png?size=600'
import vision from './images/vision.jpg?size=600'

export default class OurVision extends PureComponent {
  render() {
    const title = "Twineeds | Notre vision du travail indépendant"
    const description = "Le monde du travail évolue: retrouvez notre vision sur l'évolution du monde de l'emploi et des rapports entre entreprises, consultants & freelance."
    const figures = [
      {title: '2018', text: 'Lancement de Twineeds'},
      {title: '50%', text: 'du CAC 40'},
      {title: '+150', text: 'missions réalisées en 2022'},
      {title: '50%', text: 'des missions réalisées en province'},
    ]
    const headerBrief = <Fragment>
      <p>Twineeds est la <strong>plateforme spécialisée</strong> dans la <strong>mise en relation entre les freelances, consultants indépendants et les entreprises</strong> pour des <strong>missions orientées</strong> Achats, Supply Chain, Finance, Ingénierie et Ressources Humaines (hors IT).</p>
      <p>Présent partout en France, <strong>Twineeds accompagne les consultants experts et entreprises</strong> à Paris, Lyon, Marseille, Lille, Bordeaux, Nantes, Toulouse ou Strasbourg, facilitant la collaboration sur des missions de haut niveau, quel que soit le lieu d’intervention.</p>
      <p>Les freelances peuvent maintenant travailler avec les plus grands groupes, <strong>de manière transparente et humaine</strong>.</p>
      <p>Les clients - de la PME au CAC40 - peuvent choisir le talent avec lequel ils vont collaborer, tout en <strong>laissant à Twineeds l'administratif et les impératifs juridiques</strong>.</p>
    </Fragment>

    return (
      <DefaultLayout helmet={{title, description}} id="our-vision" showSidebarMenu={false}>
        <Header bgImg={header.src} brief={headerBrief} title="La plateforme de missions pour freelances et consultants"/>

        <section className="container py-5">
          <IllustratedDiv imgSrc={vision.src} imgAlt={'Réunion dans un bureau entre profils qualifiés'}>
            <h2 className="mb-3">Le freelancing évolue</h2>
            <p>
              Alors qu'une <strong>transformation</strong> s'est déjà amorcée avec la crise Covid, nous sommes
              convaincus que le monde du travail va profondément changer dans les années à venir.
            </p>
            <p>
              Les meilleurs talents prennent conscience de leur <strong>valeur</strong> et deviennent <strong>
              indépendants</strong> : ils se détachent ainsi du salariat traditionnel proposé par l'entreprise pour se
              mettre <strong>au service de projets</strong>.
            </p>
          </IllustratedDiv>
          <IllustratedDiv imgSrc={goal.src} imgAlt={'Consultant indépendant conseille entreprise en regardant des documents'}>
            <h2 className="mb-3">Matching entre besoin client et expertise freelance</h2>
            <p>
              Parce-que la <strong>recherche de mission</strong> peut être <strong>longue et complexe</strong>, notre
              objectif est d'aider les professionnels à trouver des opportunités afin de leur permettre de se
              concentrer sur une seule et unique activité : leur métier.
            </p>
            <p>
              Nous mettons également un point d'honneur à proposer des <strong>missions correspondant aux attentes et
              profils de chacun</strong>, privilégiant ainsi la qualité à la quantité.
            </p>
          </IllustratedDiv>
          <IllustratedDiv imgSrc={method.src} imgAlt={'Consultante experimentée conseille une entreprise devant un PC'}>
            <h2 className="mb-3">Une méthode hybride alliant expertise humaine et technologie</h2>
            <p>Notre approche phygitale s'appuie sur deux piliers distincts :</p>
            <ul>
              <li>
                Tous <strong>nos managers sont d'anciens professionnels des métiers adressés</strong> (Finance, Achats,
                Ingénierie & RH). Ils connaissent ainsi parfaitement leur métier pour une meilleure adéquation entre le
                besoin client et les profils attendus, et vice-versa.
              </li>
              <li>
                Une plateforme digitale permettant aux consultants inscrits d'être <strong>alertés par mail et
                SMS</strong> en cas de nouvelles missions postées, et d'y <strong>candidater</strong>.
              </li>
            </ul>
          </IllustratedDiv>
        </section>

        <div className="bg-light">
          <section className="container py-5">
            <IllustratedDiv imgSrc={growthGraph.src} imgAlt="Graphique en barres intitulé « Une croissance organique saine », représentant le chiffre d'affaires de Twineeds entre 2018 et 2024. Chaque barre correspond à une année : 2018 = 1, 2019 = 2, 2020 = 4, 2021 = 6, 2022 = 12, 2023 = 17 et 2024 = 18. Le graphique illustre une croissance continue et soutenue du chiffre d'affaires sur cette période.">
              <h2 className="mb-3">Une croissance continue</h2>
              <p>Depuis sa création en 2018, Twineeds connaît une croissance soutenue. Grâce à son <strong>modèle hybride alliant expertise humaine et technologie</strong>, la plateforme a vu son <strong>chiffre d’affaires passer de 1,1 million d’euros en 2018 à 18 millions d’euros en 2024</strong>.</p>
              <p>Ce développement témoigne de la confiance renouvelée des entreprises, qu’il s’agisse de PME ou de grands groupes, dans notre capacité à proposer <strong>les meilleurs consultants indépendants, les plus adaptés pour leurs projets</strong>.</p>
              <p>Notre approche sur mesure, notre fiabilité et la qualité des profils proposés font de Twineeds un <strong>acteur de référence sur le marché du freelancing B2B</strong>.</p>
            </IllustratedDiv>
          </section>
        </div>

        <div id="figures">
          <section className="container text-center py-5">
            <h2 className="mb-5">Twineeds en quelques chiffres</h2>
            <div className="row mb-5">
              {figures.map((element, index) => {
                return <div className="col-md-3 mb-2" key={index}>
                  <Card className="h-100">
                    <CardBody className="align-items-center">
                      <CardTitle className="mx-auto p-2">{element.title}</CardTitle>
                      <CardText>{element.text}</CardText>
                    </CardBody>
                  </Card>
                </div>
              })}
            </div>
            <CallToActions>
              <Link className="btn btn-primary" to={generate({name: 'register-freelance'})}>S'inscrire</Link>
              <Link className="btn btn-white" to={generate({name: 'drop-need'})}>J'ai un besoin</Link>
            </CallToActions>
          </section>
        </div>
      </DefaultLayout>
    )
  }
}

export class About extends PureComponent {
  render() {
    return <Redirect to={generate({name: 'our-vision'})}/>
  }
}
